/* eslint-disable react/jsx-props-no-spreading */
import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import { Page } from '../components/Page/Page'
import { RichText } from '../components/RichText/RichText'
import '../scss/styles.scss'
import { withSbMapping } from '../withSbMapping'
import { mapRichText } from '~/components/RichText/RichText.mapping'
import { Hero } from '~/components/Hero/Hero'
import { mapHero } from '~/components/Hero/Hero.mapping'
import { SignUpForm } from '~/components/SignUpForm/SignUpForm'
import { mapSignUpForm } from '~/components/SignUpForm/SignUpForm.mapping'
import { ConfirmSignUp } from '~/components/ConfirmSignUp/ConfirmSignUp'
import { mapConfirmSignUp } from '~/components/ConfirmSignUp/ConfirmSignUp.mapping'
import { CookieContextProvider } from '~/components/Cookies/CookieContextProvider/CookieContextProvider'
import { GoogleTagManager } from '~/components/GoogleTagManager/GoogleTagManager'
import { CookiePolicy } from '~/components/Cookies/CookiePolicy/CookiePolicy'
import { mapCookiePolicy } from '~/components/Cookies/CookiePolicy/CookiePolicy.mapping'
import { CookieDataLayer } from '~/components/Cookies/CookieDataLayer/CookieDataLayer'
import { GenericContent } from '~/components/Page/GenericContent/GenericContent'
import { mapGenericContent } from '~/components/Page/GenericContent/GenericContent.mapping'
import { ensureStoryblokInit } from '~/lib/storyblok/init'

const components = {
  page: Page,
  homepageHero: withSbMapping(Hero, mapHero),
  richtext: withSbMapping(RichText, mapRichText),
  genericContent: withSbMapping(GenericContent, mapGenericContent),
  signupForm: withSbMapping(SignUpForm, mapSignUpForm),
  confirmSignUp: withSbMapping(ConfirmSignUp, mapConfirmSignUp),
  cookiePolicy: withSbMapping(CookiePolicy, mapCookiePolicy)
}

ensureStoryblokInit(components)

const IndieWitneyApp = ({ Component, pageProps }: AppProps): React.JSX.Element => {
  const router = useRouter()

  return (
    <CookieContextProvider>
      <CookieDataLayer />
      <GoogleTagManager>
        {/* Key on the route path so the page remounts (and per-page state resets)
            when navigating between dynamic routes that share a component. */}
        <Component key={router.asPath} {...pageProps} />
      </GoogleTagManager>
    </CookieContextProvider>
  )
}

export default IndieWitneyApp
